import { useEffect, useState } from "react";
// import { useAuthContext } from "./context/AuthContext";
import { useAuthContext } from "../../context/AuthContext";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { getResult, getTrailResult } from "../../api/api";
import ic_time from "../../assets/icons/ic_time.svg";
import ic_calories from "../../assets/icons/ic_calories.svg";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import GaugeChart from "react-gauge-chart";
import LoginDialog from "../auth/LoginDialog";
import {
  BlackTextLinearGradient,
  BlueLinearGradient,
  WhiteLinearGradient,
} from "../../utils/Utils";
import useIsMobile from "../../utils/useIsMobile";
import { FeedbackDialog } from "../auth/LoginPage";

function ResultPage() {
  const { resultId } = useParams();
  const [result, setResult] = useState();
  const isMobile = useIsMobile(1024);
  const navigate = useNavigate();
  let auth = useAuthContext();

  async function fetchResult() {
    const response = await getTrailResult(resultId);
    setResult(response.result);
  }
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const workoutDone = queryParams.get("workout");
  const [showFeedBack, setShowFeedBack] = useState(
    Boolean(queryParams.get("feedback")) || false
  );
  useEffect(() => {
    fetchResult();
  }, [resultId]);

  const ExerciseAverage = ({ name, percentage }) => {
    return (
      <div className="flex flex-col px-10 mt-10 w-full ">
        <p className="font-bold text-primary-white flex basis-1/3">{name}</p>
        <div className="flex flex-row w-full items-center justify-center">
          <div className="flex flex-1 items-centerw-full bg-primary-extraLightBlue h-3 rounded-md ">
            <div
              style={{
                width: `${percentage}%`,
                background:
                  "linear-gradient(270deg, #EA2EFB 2.26%, #450BD5 136.45%)",
                transition: "width 500ms",
              }}
              className=" h-3 rounded-md"
            ></div>
          </div>
          <p className="text-primary-white dark:text-primary-neonGreen basis-1/6 text-center">
            {percentage}%
          </p>
        </div>
      </div>
    );
  };

  // for navigation to pprogram page after login
  if (auth.state.uer) {
    navigate("/programpage");
  }

  return (
    <>
      <FeedbackDialog
        showFeedBack={showFeedBack}
        workout={workoutDone}
        close={() => {
          setShowFeedBack(false);
        }}
      />
      <div className="flex flex-1 bg-black bg-contain px-5  md:px-32 space-x-10 py-10 ">
        <div className={`flex flex-1 flex-col rounded-lg`}>
          <p className="font-medium font-open-sans text-4xl text-center text-white p-5">
            Routine Complete
          </p>
          <div className="flex flex-row justify-center gap-10 items-center text-white w-full">
            <div className="flex flex-row gap-3 font-open-sans font-bold text-xl">
              <img src={ic_time} />
              <p>{result?.timeDone ? `${result?.timeDone}  mins` : "-"}</p>
            </div>
            <div className="flex flex-row gap-3 font-open-sans font-bold text-xl">
              <img src={ic_calories} />
              <p>{result?.resultCal ? `${result?.resultCal} kCal` : "-"}</p>
            </div>
          </div>
          <div className=" mt-10 flex flex-col justify-center items-center w-full">
            <div className="text-xl font-medium h-48 w-48">
              <CircularProgressbar
                styles={buildStyles({
                  textColor: "#fff",
                  pathColor: "#81D265",
                })}
                value={result ? result.result : 0}
                text={`${result ? result.result : 0}%`}
              />
            </div>
            <p className="text-white font-open-sans text-2xl mt-5 font-bold mb-10">
              Overall Performance
            </p>
          </div>
          {/* {!isMobile ? (
            <div
              className={`relative flex-col h-screen flex bg-gradient-to-br to-primary-midBlack from-primary-black rounded-lg overflow-clip`}
            >
              <p className="text-xl text-white w-full mt-10 text-center">
                Detailed performance Report
              </p>
              <div className="flex flex-col ">
                {[
                  {
                    exeriseName: "Squat",
                    percentage: 80,
                  },
                  {
                    exeriseName: "Lunges",
                    percentage: 70,
                  },
                  ,
                  {
                    exeriseName: "Squat",
                    percentage: 78,
                  },
                  ,
                  {
                    exeriseName: "Squat",
                    percentage: 90,
                  },
                  {
                    exeriseName: "Squat",
                    percentage: 50,
                  },
                  {
                    exeriseName: "Squat",
                    percentage: 65,
                  },
                ].map(({ exeriseName, percentage }) => {
                  return (
                    <ExerciseAverage
                      name={exeriseName}
                      percentage={percentage}
                    />
                  );
                })}
              </div>

              <div className="md:absolute backdrop-blur-md w-full h-full"></div>
              <div className="md:absolute md:-translate-x-1/2 md:-translate-y-1/2 md:top-1/2  md:left-1/2 max-w-lg flex flex-col justify-center items-center bg-[#0B0F19] rounded-lg pt-12">
                <p className="text-white font-poppins mb-10">
                  To see the detailed performance report
                </p>
                <LoginDialog />
              </div>
            </div>
          ) : (
            <div className=" max-w-lg flex flex-col justify-center items-center bg-[#0B0F19] rounded-lg pt-12">
              <p className="text-white font-poppins mb-10 text-center">
                To see the detailed performance report
              </p>
              <LoginDialog />
            </div>
          )} */}

          <div className="flex flex-row justify-around itmes-center">
            <button
              className="text-xs text-white bg-violet-800 cursor-pointer font-poppins font-medium rounded-xl px-10 py-6"
              onClick={() => {
                setShowFeedBack(true);
              }}
            >
              Give Feedback
            </button>
            <button
              className="text-xs text-white bg-violet-800 cursor-pointer font-poppins font-medium rounded-xl px-10 py-6"
              onClick={() => {
                navigate("/register");
              }}
            >
              Start Free Trial
            </button>
          </div>

          {/* <div
            className="text-white p-3 rounded-lg bg-primary-black mt-5 max-w-max cursor-pointer"
            onClick={() => {
              setShowFeedBack(true);
            }}
          >
            Give Feedback
          </div> */}
        </div>
      </div>
    </>
  );
}

export default ResultPage;
